<ng-container *ngIf="!datosRecibidos && errorMessage === ''">
    <div class="wait-top-container">
        <div class="wait-container">
            <span class="wait-message">Cargando datos...</span>
            <mat-progress-bar mode="indeterminate" class="progress-bar" color="warn"></mat-progress-bar>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="errorMessage !== ''">
    <div class="wait-top-container">
        <div class="wait-container">
            <div class="wait-message">{{ errorMessage }}</div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="errorMessage === '' && datosRecibidos">
    <div class="table-header">
        <div class="header-content">
            <span>HISTORIAL DE RECARGAS</span>
            <button mat-icon-button [matMenuTriggerFor]="menu" class="more-vert-btn">
                <mat-icon>more_vert</mat-icon>
            </button>
        </div>

        <span class="font14">Historial de recargas de tanques DataBeer</span>
        
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="descargarExcel()">
                <mat-icon>download</mat-icon>
                <span>Exportar a Excel</span>
            </button>
        </mat-menu>
    </div>

    <div class="mat-elevation-z8">
        <div class="top-container-container">
            <div class="top-container">
                <mat-form-field class="custom1">
                    <mat-label>Filtrar</mat-label>
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Ex.nombre" #input>
                </mat-form-field>
            </div>
        </div>

        <table mat-table [dataSource]="dataSource" matSort matSortActive="f_inicio" matSortDirection="desc">

            <ng-container matColumnDef="tank_num">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Num. de Tanque </th>
                <td mat-cell *matCellDef="let element" class="cell textAlignCenter"> {{element.tank_num}} </td>
            </ng-container>

            <ng-container matColumnDef="est_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> ID Establecimiento </th>
                <td mat-cell *matCellDef="let element" class="cell textAlignCenter"> {{element.est_id}} </td>
            </ng-container>

            <ng-container matColumnDef="cliente_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Cliente </th>
                <td mat-cell *matCellDef="let element" class="cell textAlignCenter"> {{element.cliente_name}} </td>
            </ng-container>

            <ng-container matColumnDef="est_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Establecimiento </th>
                <td mat-cell *matCellDef="let element" class="router-cell textAlignCenter" routerLink="/establecimiento/{{element.est_id}}"> {{element.est_name}} </td>
            </ng-container>

            <ng-container matColumnDef="f_inicio">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> F. de Recarga </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.f_inicio}} </td>
            </ng-container>

            <ng-container matColumnDef="litres_input">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Introducidos (L)</th>
                <td mat-cell *matCellDef="let element" class="cell textAlignCenter"> {{element.litres_input}} </td>
            </ng-container>

            <ng-container matColumnDef="litres_output">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Retirados (L) </th>
                <!-- <td mat-cell *matCellDef="let element" class="cell textAlignCenter"> {{element.litres_output}} </td> -->
                <td mat-cell *matCellDef="let element" class="cell textAlignCenter">
                    <ng-container *ngIf="userData.pro_id === 4; else checkNegative">
                      {{ element.litres_output }}
                    </ng-container>
                    <ng-template #checkNegative>
                        {{ parseLitresOutput(element.litres_output) }}
                    </ng-template>
                  </td>
            </ng-container>

            <ng-container matColumnDef="output_type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.output_type}} </td>
            </ng-container>

            <ng-container matColumnDef="beertype">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Producto </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.beertype}} </td>
            </ng-container>
        
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator 
            [pageSizeOptions]="[20,40,80]" 
            showFirstLastButtons 
            aria-label="Elige una página"
            class="custom2">
        </mat-paginator>
    </div>
</ng-container>


